import React from 'react';
var ArrowRightIcon = function () {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-arrow-right w-4 h-4" },
        React.createElement("path", { d: "M5 12h14" }),
        React.createElement("path", { d: "m12 5 7 7-7 7" })));
};
export default ArrowRightIcon;
